module.exports = "\n<div style=\"width: 100%;height: 100%;\">\n  <video [src]=\"src\"  style=\"width: 100%;height: 100%;cursor: pointer; object-fit: contain;\" (click)=\"BaseVideo.click()\"></video>\n  <input type=\"file\" #BaseVideo accept=\"video/*\" (change)=\"handleBaseFileInput($event.target.files)\"\n    style=\"width:117px; display: none;\">\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/iPOSERP/src/app/shared/component/video-uploader/video-uploader.component.html
// module id = ../../../../../src/app/shared/component/video-uploader/video-uploader.component.html
// module chunks = main